var React = require('react');
var { useMemo } = require('react');
var { getTrailPoints } = require('./useBezierPath');
var { RAINBOW_COLORS, TRAIL_LENGTH } = require('./UnicornCelebration.types');

/**
 * RainbowTrail Component
 * Renders an SVG path with rainbow gradient that follows the unicorn
 *
 * @param {Object} props
 * @param {Object} props.path - Bezier path object
 * @param {number} props.progress - Current animation progress (0-1)
 * @param {number} props.unicornId - Unique ID for gradient definition
 */
var RainbowTrail = function (props) {
  var path = props.path;
  var progress = props.progress;
  var unicornId = props.unicornId;

  // Get trail points based on current progress
  var trailPoints = useMemo(
    function () {
      return getTrailPoints(path, progress, 25);
    },
    [path, progress],
  );

  // Generate SVG path string from points
  var pathString = useMemo(
    function () {
      if (trailPoints.length < 2) return '';

      var d = 'M ' + trailPoints[0].x + ' ' + trailPoints[0].y;

      for (var i = 1; i < trailPoints.length; i++) {
        d += ' L ' + trailPoints[i].x + ' ' + trailPoints[i].y;
      }

      return d;
    },
    [trailPoints],
  );

  // Generate gradient ID
  var gradientId = 'rainbow-gradient-' + unicornId;

  if (trailPoints.length < 2) {
    return null;
  }

  return React.createElement(
    'svg',
    {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        overflow: 'visible',
      },
    },
    React.createElement(
      'defs',
      null,
      React.createElement(
        'linearGradient',
        {
          id: gradientId,
          gradientUnits: 'userSpaceOnUse',
          x1: trailPoints[0].x,
          y1: trailPoints[0].y,
          x2: trailPoints[trailPoints.length - 1].x,
          y2: trailPoints[trailPoints.length - 1].y,
        },
        RAINBOW_COLORS.map(function (color, index) {
          return React.createElement('stop', {
            key: index,
            offset: (index / (RAINBOW_COLORS.length - 1)) * 100 + '%',
            stopColor: color,
            stopOpacity: 1 - index * 0.1, // Fade as it goes back
          });
        }),
      ),
    ),
    React.createElement('path', {
      d: pathString,
      stroke: 'url(#' + gradientId + ')',
      strokeWidth: 8,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'none',
      style: {
        filter: 'blur(2px)',
      },
    }),
    // Add a sharper inner trail for more vibrancy
    React.createElement('path', {
      d: pathString,
      stroke: 'url(#' + gradientId + ')',
      strokeWidth: 4,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'none',
    }),
  );
};

module.exports = RainbowTrail;
